/* REDUCERS */
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import game from './game/reducers'
import ui from './ui/reducers'

export default combineReducers({
  game,
  ui,
  routing: routerReducer,
})

/* ACTIONS */
export * from './game/actions'
export * from './ui/actions'



// WEBPACK FOOTER //
// ./src/entities/index.js